export default __webpack_public_path__ + "static/chlopczyk-na-molo-2e8ea83a3bfa1657e1d7b6755fb7774a.jpg";